import React from "react";
import './TwitchIcon.scss';

export function TwitchIcon(props: any): React.ReactElement {
	return (
		<figure>
			<svg overflow="visible" width="40px" height="40px" version="1.1" viewBox="0 0 40 40" x="0px" y="0px">
				<g>
					<polygon points="13 8 8 13 8 31 14 31 14 36 19 31 23 31 32 22 32 8" className="purple" />
					<polygon points="26 25 30 21 30 10 14 10 14 25 18 25 18 29 22 25" className="white" />
					<g><path d="M20,14 L22,14 L22,20 L20,20 L20,14 Z M27,14 L27,20 L25,20 L25,14 L27,14 Z" className="purple" /></g>
				</g>
			</svg>
		</figure>
	);
}